export const enTranslations = {
  pricing: {
    hero: {
      betaMode: '🎉 Beta Mode Active',
      betaFree: 'Everything is free until commercial launch.',
      foundingLock: 'Founding Members lock in 30% off forever →',
      titleStart: 'Pricing That ',
      titleHighlight: "Doesn't Punish",
      titleEnd: ' Your Growth',
      subtitle:
        "When billing starts, you'll get 30 days notice. Founding Members lock in 30% off their plan — ",
      forever: 'forever',
      monthly: 'Monthly',
      annual: 'Annual',
      savePercentage: '–20%',
      freeDuringBeta: 'Free during beta',
      foundingRate: 'Founding Member rate:',
      lockedForever: '— locked forever',
      whatContractorsSay: 'What roofing contractors say about Rooflyzer OS',
    },
    features: {
      title: 'Everything Comes Standard',
      subtitle:
        "These features are included in all plans — Free, Pro, and Scale. We don't gate essential software features.",
      payForPower: 'Pay for Power,',
      notBloat: 'Not Bloat',
      modulesDesc:
        'Four focused modules you can add to any plan. Each one replaces an entire standalone SaaS tool — at a fraction of the cost.',
      usageBased: 'Usage-based',
      addToPlanBeta: 'Add to my plan during beta →',
      whiteLabelEmail: 'White-Label Email — Included Free',
      sendOwnDomain: "Send From Your Own Domain. We Don't Force Our Logo.",
      chargePrivilege:
        "Some platforms charge $10–$50/mo for the privilege of branding your outbound emails. We think that's highway robbery.",
      dummyDomain: 'outreach@yourcompany.com',
      messagingPlanDesc:
        "Any account with a ConnectIQ messaging plan (Marketing Suite or Transactional) can add their custom sending domain for free — just set your DNS records and you're ready to fly.",
    },
    comparison: {
      title: 'See Everything Side by Side',
      subtitle:
        'No cherry-picked data. This is the real feature comparison against the platforms roofers use most.',
      featureHeader: 'Feature',
      rooflyzerHeader: 'Rooflyzer OS',
      jobnimbusHeader: 'JobNimbus',
      acculynxHeader: 'AccuLynx',
      buildertrendHeader: 'Buildertrend',
    },
    calls: {
      title: 'Pay for Calls. Not for the Privilege of Making Them.',
      desc: 'CallRail charges a $45–$50/mo platform fee before you can even make a call. We charge nothing until you use it. Every charge rolls up to your next invoice — no surprise mid-month debits.',
      noPlatformFee: 'No platform fee. No monthly minimum.',
    },
    claim: {
      foundingRateTitle: 'Founding Member Rate',
      lockedForeverDesc: 'Locked in forever when billing starts',
      claimButton: 'Claim Founding Member Rate',
      learnMore: 'Learn more about the founders program →',
    },
    faq: {
      title: 'Frequently Asked Questions',
    },
    footerCTA: {
      title: 'Ready to Replace Your Entire Stack?',
      desc: 'CRM + marketing + call tracking + estimator — all in one platform, all built for roofers, all free during beta.',
      joinDesc:
        'Join hundreds of contractors already testing Rooflyzer OS. Your Founding Member rate is waiting.',
      startFree: 'Start Free — Claim Founding Rate',
      learnBeta: 'Learn About Beta Program',
      noCcRequired:
        'No credit card required · 30-day notice before billing starts · Cancel anytime',
    },
  },
  home: {
    hero: {
      badge: 'Introducing Rooflyzer OS',
      beta: 'BETA',
      titleLine1: 'The Operating System',
      titleLine2: 'for Roofing Contractors',
      getEarlyAccess: 'Get Early Access',
      readOurStory: 'Read Our Story',
      bookDemo: 'Book a Demo',
    },
    about: {
      title: 'Built by Marketers Who ',
      description:
        'CRMs built by standard developers miss the point. Rooflyzer is engineered by performance marketers. We map every click and lead source straight to closed invoice revenue, ending "lead death" forever.',
      learnMore: 'Learn More About Our DNA',
    },
    infrastructure: {
      badge: 'Complete Business Infrastructure',
      title: 'Everything You Need. Connected.',
      description:
        'Stop juggling isolated SaaS applications. Rooflyzer OS binds every coordinate, estimate, invoice, campaign, and canvassing route into one professional system of record.',
    },
    features: {
      badge: 'Complete Feature Set',
      description:
        'Click a tab below to explore exact modules and view live interface preview screens in real-time.',
      exploreAll: 'Explore All Capabilities',
    },
    workflow: {
      title: 'Your Complete Workflow',
      subtitle: 'From first contact to final payment — every step automated and connected',
      seeComplete: 'See Complete Workflow',
    },
    tech: {
      title: 'Powered By Industry-Leading Technology',
      viewAll: 'View All Integrations',
    },
    pricing: {
      badge: 'Founding Member Rates',
      title: 'The Performance to Scale ',
      description:
        "We're finalizing pricing plans that make high-end roofing tech accessible to everyone — from solo operators to national enterprises.",
      earlyAdopters: 'Early adopters will lock in exclusive founding member rates for life.',
      joinWaitlist: 'Join the Waitlist',
      slotsRemaining: 'Be the first to know when we go live • Limited slots remaining',
    },
    cta: {
      titleStart: 'Ready to Build a ',
      titleHighlight: 'Scaling',
      titleEnd: ' Roofing Business?',
      description:
        'Join the elite circle of roofing professionals transforming their operations with Rooflyzer OS.',
      getEarlyAccess: 'Get Early Access',
    },
    testimonials: {
      badge: 'Trusted by Roofers',
      title: 'What Contractors Are Saying',
      description:
        'Roofers across the country are closing more jobs and wasting less time with Rooflyzer OS.',
    },
    footerCTA: {
      title: 'Ready to Streamline Your Roofing Business?',
      description:
        'Join hundreds of roofing contractors who are closing more jobs, wasting less time, and growing faster with Rooflyzer OS.',
      startFree: 'Start Free Trial',
      bookDemo: 'Book a Demo',
    },
  },
  why: {
    hero: {
      titleStart: 'The CRM That Actually',
      titleHighlight: 'Gets Roofing',
      subtitle:
        "We didn't build another generic CRM and slap a roof icon on it. Every feature exists because real contractors asked for it — and every data point is structured so your marketing actually works.",
      startedAs: 'We started as',
      rogueMoveAgency: 'Rogue Move Digital Agency',
      startedAsSuffix:
        ", helping roofing contractors grow through data-driven marketing. We discovered a critical gap: the tools contractors needed didn't exist. So we built them — with complete data visibility from first click to final payment.",
      seeAllFeatures: 'See All Features',
      compareCompetitors: 'Compare With Competitors',
    },
    differentiators: {
      title: 'A Fundamentally Different Approach',
      subtitle:
        'Built by marketers who understand the complete customer journey — from first click to final payment. Every feature is designed with data visibility in mind.',
    },
  },
};
